import React from "react";
import { PieChart, Pie, Cell } from "recharts";
import formateText from "../../../../utils/Formate";

const PieChartComponenet = ({
  data,
  tittle,
  hideTitle = false,
  innerRadius = 0,
}) => {
  const COLORS = (data || []).map((item) => item.color);
  const RADIAN = Math.PI / 180;

  const customizedLevel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
  }) => {
    if (!percent) return null;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
        fontSize={12}
        fontWeight={700}
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <div className="h-full w-full">
      {hideTitle ? null : (
        <h1 className="text-lg font-semibold text-stone-900 mb-1">
          {formateText(tittle)}
        </h1>
      )}
      <div className="flex justify-center items-center flex-col">
        <PieChart width={280} height={240}>
          <Pie
            data={data}
            innerRadius={innerRadius}
            outerRadius={100}
            fill="#8884d8"
            label={customizedLevel}
            paddingAngle={2}
            dataKey="value"
            stroke="#fff"
            strokeWidth={2}
          >
            {data?.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
        </PieChart>
        <div className="w-full flex justify-start flex-col gap-2.5">
          {data?.map((item) => (
            <div
              key={item.name}
              className="flex items-center justify-between gap-3"
            >
              <span className="flex items-center gap-2 min-w-0">
                <span
                  style={{ background: item.color }}
                  className="w-3 h-3 rounded-full inline-block shrink-0"
                />
                <span className="text-sm font-semibold text-stone-700 truncate">
                  {formateText(item.name)}
                </span>
              </span>
              <span className="text-sm font-bold tabular-nums text-stone-900">
                {item.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PieChartComponenet;
